import { breakpoint, colors, fontSize, fontWeight, mediaQueryHelper, spacing, textStyles } from '@offerzen/pinata-shame'
import { css } from '@emotion/css'

const styles = {
  heading: css({
    marginBottom: spacing.medium,
    fontWeight: fontWeight.medium,
    color: colors.blackPearl,
  }),

  text: css({
    ...textStyles,
    marginBottom: spacing.large,
  }),

  subTitle: css({
    ...textStyles,
    color: colors.blackPearl,
  }),

  subHeading: css({
    ...textStyles,
    marginBottom: spacing.default,
    color: colors.blackPearl,
  }),

  socialNetwork: css({
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center',
    marginBottom: spacing.large,

    [mediaQueryHelper(breakpoint.phone)]: {
      justifyContent: 'flex-end',
      marginBottom: spacing.large,
    },
  }),

  socialNetworkIcon: css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    height: 24,
    borderRadius: '50%',
    background: colors.hawkesBlue,
    marginRight: spacing.default,

    '& img': {
      width: 9,
    },
  }),

  socialNetworkName: css({
    fontSize: fontSize.small,
    color: colors.oxfordBlue,
    fontWeight: fontWeight.semiBold,
    marginRight: 'auto',
  }),

  socialNetworkInput: css({
    width: '100%',
    marginTop: spacing.default,
    marginBottom: 0,
    '& input': {
      border: 'none',
      height: '100%',
    },
    [mediaQueryHelper(breakpoint.phone)]: {
      width: 320,
      marginTop: 0,
    },
  }),

  footer: css({
    marginTop: spacing.large,
  }),

  notification: css({
    marginTop: spacing.medium,
  }),

  tag: css({
    marginRight: spacing.small,
  }),

  uploadFile: css({
    marginBottom: spacing.default,
    'span:nth-child(2)': {
      color: colors.grayChateau,
    },

    'span:last-child': {
      fontSize: fontSize.default,
    },
  }),
}

export default styles
